import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import Router from "./Router"
import { Auth0Provider } from "@auth0/auth0-react";

ReactDOM.render(
  <Auth0Provider
    domain="mendel-software.us.auth0.com"
    clientId="wSbesxpMUBFn3UgEArBnCab91wdEtApM"
    redirectUri="https://martabsantiso.com/panelcentral"
    audience="https://turnos.marta.api/"
    scope="admin:consul"
  >
  <React.StrictMode>
    <Router />
  </React.StrictMode>
  </Auth0Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
